/** Analytics Portal V1 — shared availability / suppression notice (Phase 9, C2 + §10.8).
 * Always renders the SERVER's copy; the browser never invents an explanation. */
import React from "react";
import { Info } from "lucide-react";

export const AvailabilityNotice = ({ notice, reason, testId = "analytics-availability-notice",
                                     className = "" }) => {
  if (!notice) return null;
  return (
    <p className={`flex items-start gap-2 rounded-lg border border-border bg-secondary/60 px-3 py-2 text-xs leading-snug text-muted-foreground ${className}`}
       data-testid={testId} data-reason={reason || undefined} role="note">
      <Info className="mt-0.5 h-3.5 w-3.5 shrink-0" aria-hidden="true" />
      <span>{notice}</span>
    </p>
  );
};
